/**
 * Application main entry point.
 */
import "./config";

import App from "./App";
import { boot } from "./bootstrap";

boot(App);
